<p-fieldset styleClass="mt-2">
    <ng-template pTemplate="header">
        <div class="d-flex">
            <fa-icon [icon]='["far","user-tie"]'></fa-icon>
            <div class="mx-2">
                Ownership & Point of Contact Information
            </div>
            <div *ngIf="recordError" class="ms-1 text-danger">
                {{recordError}}
            </div>
            <fa-icon [icon]='["far","check-double"]' *ngIf="sectionComplete"></fa-icon>
            <div class="ms-auto">
                <fa-icon [icon]='["far","question-circle"]' (click)="displayModal.emit('owner')"></fa-icon>
            </div>
        </div>
    </ng-template>
    <div class="d-flex text-center">
        Please list all owners with 20% or more ownership.
    </div>
    <ng-container *ngFor="let contact of merchantContacts; let idx = index" class="mb-2">
        <app-merchant-contact-record [contact]="contact" [contactIdx]="idx" [readOnly]="readOnly" (inputActionEmitter)="inputAction($event)" (subSectionCompleteEmitter)="sectionChange($event)" (contactPocChangeEmitter)="contactPocChange($event)" (removeContactEmitter)="merchantContacts.splice($event,1)"></app-merchant-contact-record>
    </ng-container>
    <div class="d-flex">
        <p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="ownerContactAdd()">
            <ng-template pTemplate="content">
                <div class="d-flex justify-content-center">
                    <fa-icon [icon]='["far","user-plus"]' size="lg" class="ms-1 me-2"></fa-icon>
                    <div class="mx-2">
                        Add an owner
                    </div>
                </div>
            </ng-template>
        </p-button>
    </div>
</p-fieldset>